import { render, staticRenderFns } from "./CanvasViewer.vue?vue&type=template&id=566a4a20&scoped=true"
import script from "./CanvasViewer.vue?vue&type=script&lang=js"
export * from "./CanvasViewer.vue?vue&type=script&lang=js"
import style0 from "./CanvasViewer.vue?vue&type=style&index=0&id=566a4a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a4a20",
  null
  
)

export default component.exports